import React, { Fragment } from 'react';

import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import Currency from 'components/currency';
import { LayoutContainer } from 'components/layout/styled';

import { Container, Total, TotalLabelTitle, TotalsRow } from './modal-order-details.styled';
import { OrderItem } from './order-item';
import { OrderPricesDetails } from './order-prices-details';
import { OrderRewardDetails } from './order-reward-details';

type ModalOrderDetailsProps = {
  showModal: boolean;
  onCloseModal: React.Dispatch<React.SetStateAction<void>>;
  serverOrder: IServerOrder;
};

const ModalOrderDetails = ({ showModal, onCloseModal, serverOrder }: ModalOrderDetailsProps) => {
  const { cart, loyaltyTransaction } = serverOrder;
  const { formatMessage } = useIntl();

  return (
    <ActionsheetWrapper
      onOpenEventMessage="View Order Details"
      isOpen={showModal}
      onClose={onCloseModal}
    >
      <ActionsheetContent padding={0}>
        <Container>
          <LayoutContainer isModal>
            {cart.cartEntries.map(entry => (
              <Fragment key={entry.lineId}>
                <OrderItem cartEntry={entry} />
              </Fragment>
            ))}

            <OrderPricesDetails cart={cart} />

            {loyaltyTransaction && <OrderRewardDetails loyaltyTransaction={loyaltyTransaction} />}

            <TotalsRow>
              <TotalLabelTitle>{formatMessage({ id: 'total' })}</TotalLabelTitle>
              <Total fontSize="md">
                <Currency isBold amount={cart.totalCents} />
              </Total>
            </TotalsRow>
          </LayoutContainer>
        </Container>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};

export default ModalOrderDetails;
